import { useCallback, useEffect, useState } from "react";
import { Drawer, Button } from "antd";
import { payxpress_logo } from "@/assets";
import { PrivacyPreference } from "./PrivacyPreference";
import Cookies from "js-cookie";
import { CloseOutlined } from "@ant-design/icons";

export const CookiesSettings = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openPreference, setOpenPreference] = useState(false);

  const onClose = () => {
    setIsOpen(false);
    Cookies.set("cookiesAccepted", "false", {
      expires: 365,
    });
  };

  const setCookies = useCallback(
    (isAccepted: boolean) => {
      setIsOpen(false);
      setOpenPreference(false);
      Cookies.set("cookiesAccepted", isAccepted ? "true" : "false", {
        expires: 365,
      });
    },
    [setIsOpen, setOpenPreference]
  );

  useEffect(() => {
    const accepted = Cookies.get("cookiesAccepted"); // Read from cookies
    if (accepted === "true" || accepted === "false") {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  }, []);

  return (
    <>
      <PrivacyPreference
        acceptCookies={setCookies}
        open={openPreference}
        setOpen={setOpenPreference}
      />
      <Drawer
        placement={"bottom"}
        closable={false}
        onClose={onClose}
        open={isOpen}
        height="auto"
        key={"1"}
        mask={false}
        maskClosable={true}
        styles={{ header: { display: "none" } }}
      >
        <div className="flex flex-col lg:grid lg:grid-cols-[60%_30%] px-4 lg:px-7 gap-4 lg:gap-[10%] py-4">
          <div className="flex flex-col lg:flex-row lg:justify-between gap-4 lg:gap-11">
            <img
              src={payxpress_logo}
              alt=""
              className="w-[4rem] lg:w-[5rem] mx-auto lg:mx-0"
            />
            <span className="text-gray-400 font-medium text-sm lg:text-base text-center lg:text-left">
              By clicking "Accept All Cookies", you agree to the storing of
              cookies on your device to enhance site navigation, analyze site
              usage, and assist in our marketing efforts. Also, closing out the
              cookie box without confirming your choice indicates consent.
              Closing out the cookie box without confirming your choice
              indicates consent
            </span>
          </div>
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
            <div className="flex flex-col sm:flex-row gap-3 order-2 lg:order-1">
              <Button
                onClick={() => setOpenPreference(true)}
                className="h-[40px] lg:h-[45px] bg-white text-green-800 border-green-800 hover:!text-white text-sm lg:text-base"
              >
                Cookies Settings
              </Button>
              <Button
                onClick={() => setCookies(true)}
                className="h-[40px] lg:h-[45px] bg-green-800 text-white hover:!text-white text-sm lg:text-base"
              >
                Accept All Cookies
              </Button>
            </div>

            <CloseOutlined
              onClick={() => setCookies(false)}
              className="bg-gray-400 p-1 text-white rounded-full font-semibold cursor-pointer hover:bg-red-500 self-end lg:self-auto order-1 lg:order-2"
            />
          </div>
        </div>
      </Drawer>
    </>
  );
};
